import MessageSVG from "@design-system/ui-icons/vanilla/Message"
import { createIcon } from "../createIcon"

export const MessageIcon = createIcon(MessageSVG)
